<!--充值记录-->
<template>
  <div>
    <a-spin :spinning="loading">
      <a-form ref="form" :model="formState" name="form" @finish="onSearch">
        <a-row>
          <a-form-item class="ui-form__item" name="organizationId" label="影院组织" v-if="fundMode == 2">
            <a-select placeholder="请选择影院组织" v-model:value="formState.organizationId" style="width: 250px;"
                      @change="getAllCinemaList">
              <a-select-option v-for="item in organizationList" :vlaue="item.id" :key="item.id">
                {{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item class="ui-form__item" name="cinemaId" label="所属影院" v-if="fundMode == 2">
            <a-select placeholder="请选择所属影院" v-model:value="formState.cinemaId" style="width: 250px;">
              <a-select-option :value="999">全部</a-select-option>
              <a-select-option :value="0">项目预存</a-select-option>
              <a-select-option v-for="item in cinemaAllList" :vlaue="item.id" :key="item.id">
                {{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="充值时间" class="ui-form__item">
            <a-range-picker v-model:value="time"></a-range-picker>
          </a-form-item>

          <a-form-item class="ui-form__item" label="操作人" name="userInfo">
            <a-input placeholder="请输入" v-model:value="formState.userInfo"></a-input>
          </a-form-item>

        </a-row>

        <a-row>
          <a-col :span="18">
            <!--						<a-button v-permission="['ciname_basis_filmTicket_add']" type="primary" @click="onAdd">批量释放</a-button>-->
            <span>
							<ExportReport v-permission="['fundCenter_recharge_export']" type="preStoreRecord" :searchData="searchData"></ExportReport>
						</span>
          </a-col>
          <a-col :span="6" style="text-align: right;">
            <a-button style="margin-right: 10px" type="primary" html-type="submit">搜索</a-button>
            <a-button @click="reset">重置</a-button>
          </a-col>
        </a-row>
      </a-form>

      <div style="margin-top: 20px;">
        <a-table rowKey="id" :pagination="pagination" :columns="columns" :dataSource="list">
          <template #bodyCell="{ column, record }">
            <template v-if="column.dataIndex === 'cinemaName'">
              {{record.cinemaName ? record.cinemaName : '项目预存'}}
            </template>
            <template v-if="column.dataIndex === 'createTime'">
              <template v-if="record.createTime">{{ transDateTime(record.createTime) }}</template>
              <template v-else>-</template>
            </template>
          </template>
        </a-table>
      </div>
    </a-spin>
    <Mode :showConfigMode="showConfigMode" @onRefreshMode="getSettingDetail" @onRefresh="onSearch" @close="onClosePage"></Mode>
  </div>
</template>

<script>
  import {
    Icon
  } from '@/components/icon/icon.js';
  import {
    getOrganizationList,
    getCinemaList,
  } from '@/service/modules/cinema.js';
  import {
    getRechargeList, getSettingDetail
  } from "@/service/modules/preStoreCenter.js";

  import ExportReport from '@/components/exportReport/exportReport.vue';
  import Mode from '../components/mode.vue';

  export default {
    components: {
      Icon,
      ExportReport,
      Mode
    },
    data() {
      return {
        loading: false,
        showAll: false,
        organizationList: [],
        cinemaAllList: [],
        time: [],
        formState: {
          organizationId: 0,
          cinemaId: 999
        },
        searchData: {},
        list: [],
        showConfigMode: false,
        fundMode: 0,
        columns: [{
          title: '所属影院',
          dataIndex: 'cinemaName'
        }, {
          title: '发生前余额',
          dataIndex: 'beforeBalance',
        }, {
          title: '变动金额',
          dataIndex: 'amount',
        }, {
          title: '发生后余额',
          dataIndex: 'afterBalance',
        }, {
          title: '操作人',
          dataIndex: 'adminUserName'
        }, {
          title: '充值时间',
          dataIndex: 'createTime'
        }],
        pagination: {
          showSizeChanger: true,
          showQuickJumper: true,
          size: "middle",
          showTotal: (total) => {
            return "共 " + total + " 条";
          },
          total: 0,
          current: 1,
          pageSize: 10,
          onChange: (page) => {
            this.pagination.current = page;
            this.getAllCinemaList();
          },
          onShowSizeChange: (page, pageSize) => {
            this.pagination.current = 1;
            this.pagination.pageSize = pageSize;
            this.getAllCinemaList();
          }
        },

      }
    },
    created() {
      this.getSettingDetail();
      this.getOrganizationList();
      this.onSearch();
    },
    methods: {
      onBack(isRef) {
        this.showModal = false;
        if (isRef) {
          this.getAllCinemaList();
        }
      },
      onSearch() {
        this.pagination.current = 1;
        this.searchData = JSON.parse(JSON.stringify(this.formState));
        this.searchData.organizationId = this.searchData.organizationId ? this.searchData.organizationId : undefined;
        this.searchData.id = this.searchData.id ? this.searchData.id : undefined;
        if (this.time && this.time.length) {
          this.searchData.createStartTime = this.time[0].startOf('day').unix();
          this.searchData.createEndTime = this.time[1].endOf('day').unix();
        }
        // this.getAllCinemaList();
        this.getRechargeList();
      },
      reset() {
        this.$refs.form.resetFields();
        this.onSearch();
      },
      onSubmit() {
        this.$refs.addForm.validateFields().then(async () => {
          this.loading = true;
          try {
            let postData = {
              ...this.modelRef
            }
            let ret = await updateFilmMode(postData);
            this.loading = false;
            if (ret.code === 200) {
              this.$message.success('操作成功');
              this.$refs.addForm.resetFields();
              this.showModal = false;
              this.modelRef = {};
              this.cinemaAllList();
            }
          } catch (e) {
            this.loading = false;
          }
        })
      },
      onCancel() {
        this.$refs.addForm.resetFields();
        this.modelRef = {};
        this.showModal = false;
      },
      async getOrganizationList() {
        let ret = await getOrganizationList({
          page: 1,
          pageSize: 999999
        });
        if (ret.code === 200) {
          this.organizationList = ret.data.list;
          if (this.organizationList.length) {
            this.formState.organizationId = this.organizationList[0].id;
            this.getAllCinemaList(this.formState.organizationId);
          }
        }
      },
      async getAllCinemaList(organizationId) {
        this.cinemaAllList = [];
        this.formState.cinemaId = 999;
        let ret = await getCinemaList({
          page: 1,
          pageSize: 999999,
          organizationId: organizationId ? organizationId : undefined,
        })
        if (ret.code === 200) {
          this.cinemaAllList = ret.data.list;
        }
      },
      async getRechargeList() {
        const postData = {
          ...this.searchData,
          type: 2,
        };
        if (postData.cinemaId == 999) {
          delete postData.cinemaId;
        }
        delete postData.organizationId;
        const ret = await getRechargeList(postData);
        if (ret.code == 200) {
          this.list = ret.data.list;
        }
      },
      onClosePage() {
        this.showConfigMode = false;
        this.$closePage(this.$router.currentRoute.value, '/index');
      },
      async getSettingDetail() {
        const ret = await getSettingDetail();
        if (ret.code == 200) {
          if (!Object.keys(ret.data).length || ret.data == 0) {
            this.showConfigMode = true;
            return
          }
          this.fundMode = ret.data;
          this.showConfigMode = false;
        }
      },
    }
  }
</script>

<style scoped>
    .ui-form__item {
        margin-right: 30px;
    }
</style>
